<template>
  <NormalView is-verify />
</template>
<script>
import NormalView from '@/views/center-business/stock/lock/view';
export default {
  name: 'BusinessStockVerifyLockView',
  components: {
    NormalView,
  },
  mixins: [],
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped></style>
